<header>
  <rrp-header />
  <rrp-system-notification />
</header>

<div class="container">
  <router-outlet />
</div>

@if (!hideFooter()) {
  <rrp-general-footer />
}
